import React, { Component } from 'react'
import { applyMiddleware } from 'redux';
import style from './PanelIndicators.css'
import api from '../../../apiClient/v1';
import ButtonArchivoPUC from '../ButtonArchivoPUC.jsx';
import ComentarioIG from '../ComentarioIG.jsx';
import ModalBloqueo from '../ModalBloqueo.jsx';

export class RowIndicators extends Component {
    constructor(props) {
        super(props)
        this.state = {
            date: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
            interval: 0,
            atrasado: false,
            iniciado: false,
            showModalBloqueo: false,
            selectedClient: null,
            selectedUserId: null,
            selectedUser: null
        }
    }
    abrirModalBloqueo = (idUsuario, clientName, nombre) => {
        this.setState({
            showModalBloqueo: true,
            selectedClient: clientName,
            selectedUserId: idUsuario,
            selectedUser: nombre
        })
    }
    cerrarModalBloqueo = () => {
        this.setState({ showModalBloqueo: false })
    }
    timer(newDateObj) {
        var today = new Date();
        const yyyy = today.getFullYear();
        let mm = today.getMonth() + 1; // Months start at 0!
        let dd = today.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        const formattedToday = yyyy + '-' + mm + '-' + dd;
        var hoy = new Date(formattedToday).getTime()
        var prog = new Date(this.props.indicator.fecha).getTime()
        if (hoy == prog) {
            //&& this.props.indicator.leader != " Suspendido" 
            if (this.props.indicator.inv_report == 0 && this.props.indicator.leader != " Suspendido" && this.props.indicator.client_name != "SMU") {
                const interval = setInterval(() => {
                    this.setState({ date: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }) })
                    if (this.state.date >= this.props.indicator.horario) {
                        this.setState({
                            timer: 1
                        })
                        api.reportes.getReporte(this.props.indicator.inv)
                            .then(resp => {
                                if (resp == false && this.state.date >= newDateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })) {
                                    this.setState({
                                        atrasado: true
                                    })
                                }
                                if (resp == true && this.state.date >= newDateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })) {
                                    this.setState({
                                        atrasado: false,
                                        iniciado: true
                                    })
                                    clearInterval(this.state.interval)
                                }
                            })
                            .catch(err => {
                                console.log(err)
                            })
                    }
                }, 30000);
                this.setState({ interval: interval })
            }
        }
    }
    componentDidMount() {
        var newDateObj = new Date(new Date().toDateString() + ' ' + this.props.indicator.horario)
        newDateObj.setMinutes(newDateObj.getMinutes() + 10)
        this.timer(newDateObj)
    }
    componentWillUnmount() {
        clearInterval(this.state.interval)
    }

    render() {
        const { showModalBloqueo, selectedClient, selectedUserId, selectedUser } = this.state
        let cargatxt = this.props.perms.cargatxt != null ? this.props.perms.cargatxt : false;
        //console.log(this.state.date, this.props.indicator.horario, this.state.atrasado)
        //console.log(this.state.fecha, this.props.indicator.fecha)
        let totales = {
            cantError: 0,
            conteo: 0
        };
        //let desvio = aInt(this.props.indicator.indicator.diff_counted_informed) < 0 ? (aInt(this.props.indicator.indicator.diff_counted_informed) * -1) : aInt(this.props.indicator.indicator.diff_counted_informed)
        //let desviacion = this.props.indicator.stock_teorico * 0.002 < desvio ? <td><strong style={{ color: 'red' }}>{this.props.indicator.indicator.diff_counted_informed}</strong></td> : <td>{this.props.indicator.indicator.diff_counted_informed}</td>
        let totalConteo = aInt(this.props.indicator.indicator.units_counted)
        let tdVariance = this.props.permissions
            ? (parseFloat(this.props.indicator.indicator.variance).toFixed(1) > 0.1 || parseFloat(this.props.indicator.indicator.variance).toFixed(1) < -0.1
                ? <td><strong style={{ color: 'red' }}>{this.props.indicator.indicator.variance}</strong></td>
                : <td>{this.props.indicator.indicator.variance}</td>) : <td>{this.props.indicator.indicator.variance}</td>
        let tdTiempoConteo = (this.props.indicator.indicator.ig_hours ?
            (this.props.indicator.indicator.tiempo_conteo ?
                (this.props.indicator.indicator.tiempo_conteo <= '00:30:00' ?
                    (<td className={this.props.permissions && this.props.indicator.indicator.incumplimientos_sei &&
                        this.props.indicator.indicator.incumplimientos_sei.bajoRevision ? style.tooltip : ''}>
                        <strong style={{ color: 'red' }}>
                            {this.props.indicator.indicator.tiempo_conteo}
                        </strong>
                        {this.props.permissions && this.props.indicator.indicator.incumplimientos_sei &&
                            this.props.indicator.indicator.incumplimientos_sei.bajoRevision &&
                            (<span className={style.tooltiptext}>
                            {this.props.indicator.indicator.incumplimientos_sei.bajoRevision.observacion
                                ? this.props.indicator.indicator.incumplimientos_sei.bajoRevision.observacion
                                : 'Sin observaciones aún...'}
                            {/* {this.props.indicator.indicator.incumplimientos_sei.revision.motivos_revision &&
                                this.props.indicator.indicator.incumplimientos_sei.revision.motivos_revision.length > 0 &&
                                (<div>
                                    <br />
                                    Motivos:
                                    <br />
                                    {this.props.indicator.indicator.incumplimientos_sei.revision.motivos_revision
                                        .map(item => item.motivo && item.motivo.nombre).filter(Boolean).join(', ')}
                                </div>
                                )} */}
                        </span>
                            )}
                    </td>
                    )
                    : <td>{this.props.indicator.indicator.tiempo_conteo}</td>
                )
                : <td>Sin Registro</td>
            )
            : <td></td>
        );
        let tdFCVConteo = this.props.indicator.indicator.ig_hours ? (this.props.indicator.indicator.tiempo_conteo ? <td>{this.props.indicator.indicator.tiempo_conteo}</td> : <td>Sin Registro</td>) : <td></td>
        let tdNotaConteo = (parseFloat(this.props.indicator.indicator.nota_conteo).toFixed(1) <= 6.0 ? <td className={style.tooltip}><strong style={{ color: 'red' }}>{this.props.indicator.indicator.nota_conteo}</strong><span className={style.tooltiptext} style={{ width: '400px', whiteSpace: 'normal' }}><strong>Incumplimiento: </strong>{this.props.indicator.indicator.incumplimientos_sei && this.props.indicator.indicator.incumplimientos_sei.notaConteo && this.props.indicator.indicator.incumplimientos_sei.notaConteo.observacion ? this.props.indicator.indicator.incumplimientos_sei.notaConteo.observacion : 'Sin observaciones aún...'}</span></td> : <td>{this.props.indicator.indicator.nota_conteo}</td>)

        let liderNombre = this.props.indicator.indicator.tooltip_lider ? this.props.indicator.indicator.tooltip_lider.Titular : null
        let liderCantError = this.props.indicator.indicator.tooltip_lider ? this.props.indicator.indicator.tooltip_lider.CantError : null
        let liderError = this.props.indicator.indicator.tooltip_lider ? this.props.indicator.indicator.tooltip_lider.Error : null
        let liderConteo = this.props.indicator.indicator.tooltip_lider ? this.props.indicator.indicator.tooltip_lider.Conteo : null
        totales.cantError += !isNaN(parseInt(liderCantError)) ? parseInt(liderCantError) : 0;
        totales.conteo += !isNaN(parseInt(liderConteo)) ? parseInt(liderConteo) : 0;

        let span = this.props.indicator.indicator.tooltip_titulares ? (
            <span className={style.tooltiptext}>{this.props.indicator.client_name == 'CID' ? (this.props.admin ? "Error ITEMS corregidos" : "Error Patentes corregidas") : null}{this.props.indicator.client_name == 'CID' && <br />}
                {this.props.indicator.client_name} - {this.props.indicator.store_number} - {this.props.indicator.store_name}<br />
                <table style={{
                    fontSize: '12px',
                    width: '100%',
                }}>
                    <thead>
                        <tr>
                            <th className={style.PanelIndicators_thTitulos}></th>
                            <th className={style.PanelIndicators_thTitulos}>Comuna</th>
                            <th className={style.PanelIndicators_thTitulos}>Cant.Error</th>
                            <th className={style.PanelIndicators_thTitulos}>Error</th>
                            <th className={style.PanelIndicators_thTitulos}>Conteo</th>
                            <th className={style.PanelIndicators_thTitulos}>EXP</th>
                            {this.props.perms.canBlock && <th className={style.PanelIndicators_thTitulos}></th>}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className={style.PanelIndicators_tdLiderName}>{liderNombre}</td>
                            <td className={style.PanelIndicators_tdLiderName}></td>
                            <td className={style.PanelIndicators_tdLiderStats}>{liderCantError}</td>
                            <td className={style.PanelIndicators_tdLiderStats}>{liderError}</td>
                            <td className={style.PanelIndicators_tdLiderStats}>{miles(liderConteo)}</td>
                        </tr>
                        {this.props.indicator.indicator.tooltip_titulares.map((titular, index) => {
                            totales.cantError += !isNaN(parseInt(titular.CantError)) ? parseInt(titular.CantError) : 0;
                            totales.conteo += !isNaN(parseInt(titular.Conteo)) ? parseInt(titular.Conteo) : 0;
                            return <tr key={index}>
                                <td className={style.PanelIndicators_tdName}>{titular.Titular}</td>
                                <td className={style.PanelIndicators_tdName}>{titular.Comuna}</td>
                                <td className={style.PanelIndicators_tdStats}>{titular.CantError}</td>
                                <td className={style.PanelIndicators_tdStats}>{titular.Error}</td>
                                <td className={style.PanelIndicators_tdStats}>{miles(titular.Conteo)}</td>
                                <td className={style.PanelIndicators_tdStats}>{titular.EXP}</td>
                                {this.props.perms.canBlock && <td>
                                    <button className='btn btn-danger btn-xs'
                                        onClick={() => this.abrirModalBloqueo(titular.idUsuario, this.props.indicator.client_name, titular.Titular)}
                                        style={{ display: 'flex', maxHeight: '8px', maxWidth: '8px', alignItems: 'center', justifyContent: 'center' }}>
                                        <span className="glyphicon glyphicon-ban-circle"></span>
                                    </button>
                                </td>}
                            </tr>
                        })}
                    </tbody>
                    <tfoot>
                        <tr style={{ borderTop: '1px solid white' }}>
                            <td className={style.PanelIndicators_totalesName}>Otros:</td>
                            <td className={style.PanelIndicators_totales} ></td>
                            <td className={style.PanelIndicators_totales} >0</td>
                            <td className={style.PanelIndicators_totales}>0</td>
                            <td className={style.PanelIndicators_totales}>{miles(totalConteo - totales.conteo)}</td>
                            <td className={style.PanelIndicators_totales}>0</td>
                        </tr>
                        <tr>
                            <td className={style.PanelIndicators_totalesName}>Totales:</td>
                            <td className={style.PanelIndicators_totales}></td>
                            <td className={style.PanelIndicators_totales} >{totales.cantError}</td>
                            <td className={style.PanelIndicators_totales}></td>
                            <td className={style.PanelIndicators_totales}>{this.props.indicator.indicator.units_counted}</td>
                            <td className={style.PanelIndicators_totales}></td>
                        </tr>
                    </tfoot>
                </table>
                {this.props.permissions && this.props.indicator.indicator.incumplimientos_sei &&
                    this.props.indicator.indicator.incumplimientos_sei.errorOperadores && (
                        <div style={{ whiteSpace: 'normal' }}>
                            {/* <p style={{ whiteSpace: 'pre-wrap' }}>
                                <strong>Incumplimiento:</strong>{' '}
                                {this.props.indicator.indicator.incumplimientos_sei.errorOperadores.observacion ||
                                    'Sin observaciones aún...'}
                            </p> */}
                            {this.props.indicator.indicator.incumplimientos_sei.errorOperadores.operadores &&
                                this.props.indicator.indicator.incumplimientos_sei.errorOperadores.operadores.map(
                                    operador => (<div key={operador.id} style={{ marginLeft: '5px', marginBottom: '5px'}}>
                                            <strong>
                                                {operador.usuario.nombre1}{' '}
                                                {operador.usuario.apellidoPaterno}
                                            </strong>
                                            {' - '}
                                            Error: {operador.porcentaje_error}%
                                            {' - '}
                                            Cantidad: {operador.cantidad}
                                            <br />
                                            Comentario:{' '}
                                            {operador.comentario || 'Sin comentario'}
                                        </div>
                                    )
                                )}
                        </div>
                    )}
            </span>) : null
        let spanNomina = this.props.indicator.indicator.tooltip_nomina ?
            <span className={style.tooltiptextCECO}>
                Prod.Sugerida: {this.props.indicator.indicator.tooltip_nomina.prod_sugerida}<br />
                Llegada inventario: {this.props.indicator.indicator.tooltip_nomina.hora_llegada}<br />
                Tot. hrs. conteo: {this.props.indicator.indicator.tooltip_nomina.total_horas_conteo}<br />
                Dotación: {this.props.indicator.indicator.tooltip_nomina.dotacion}<br />
                Total sala: {this.props.indicator.indicator.tooltip_nomina.total_sala}<br />
                Total bodega: {this.props.indicator.indicator.tooltip_nomina.total_bodega}<br />
                Tot. unds teórico: {this.props.indicator.indicator.tooltip_nomina.total_teorico}<br />
                Nota presentación: {this.props.indicator.indicator.tooltip_nomina.nota_presentacion}<br />
                Nota supervisor: {this.props.indicator.indicator.tooltip_nomina.nota_supervisor}<br />
            </span> : null

        let spanJL = <span className={style.tooltiptext}>{this.props.indicator.indicator.tooltip_jl ? this.props.indicator.indicator.tooltip_jl : 'No informado'}</span>

        /*let spanNomina = indicator.indicator.tooltip_nomina ?
            <span className={style.tooltiptextCECO}>
                Prod.Sugerida: {miles(indicator.indicator.tooltip_nomina.prod_sugerida)}<br />
                Llegada inventario: {indicator.indicator.tooltip_nomina.hora_llegada}<br />
                Tot. hrs. conteo: {indicator.indicator.tooltip_nomina.total_horas_conteo}<br />
                Dotación: {indicator.indicator.tooltip_nomina.dotacion}<br />
                Total sala: {indicator.indicator.tooltip_nomina.total_sala}<br />
                Total bodega: {indicator.indicator.tooltip_nomina.total_bodega}<br />
                Tot. unds teórico: {indicator.indicator.tooltip_nomina.total_teorico}<br />
                Nota presentación: {indicator.indicator.tooltip_nomina.nota_presentacion}<br />
                Nota supervisor: {indicator.indicator.tooltip_nomina.nota_supervisor}<br />
            </span> : null*/

        let styleTR = this.props.indicator.es_dia ? '#fdfd96' : null
        styleTR = this.props.indicator.inv_especial ? "#B8F2C2" : styleTR;

        //let atrasoReporte = updateTime(indicator.horario, date)

        let statusReporte1 = this.props.indicator.inv_report.length >= 1 ?
            <p style={{ fontSize: '12px' }}>1. Iniciado: <br />
                Dotacion equipo: {((Number(this.props.indicator.inv_report[0].dotacion) * 100) / this.props.indicator.dotacion).toFixed(1) + "%"}
                {this.props.indicator.inv_report[0].idDescripcionReportesIG == 1
                    ? " - Dotación completa" :
                    (this.props.indicator.inv_report[0].idDescripcionReportesIG == 2
                        ? " - Dotación incompleta, faltante en camino" : " - Dotación incompleta")} <br />
                Observaciones: {this.props.indicator.inv_report[0].comentario.length > 0 ? this.props.indicator.inv_report[0].comentario : ""}<br />
                {this.props.comentarioDashboard ? (this.props.indicator.inv_report[0].idUser ? "Reportado por: " + this.props.indicator.inv_report[0].idUser : "Usuario encargado de reportar no registrado") : null}
            </p> : "Reporte aún no iniciado"

        let statusReporte2 = this.props.indicator.inv_report.length >= 2 ?
            <p style={{ fontSize: '12px' }}>2. Avance: Uni. Teo: {miles(this.props.indicator.stock_teorico)} - Uni. Con: {miles(((this.props.indicator.stock_teorico * this.props.indicator.inv_report[1].avance) / 100).toFixed())} - %Error: {this.props.indicator.inv_report[1].error + "%"}<br />
                Hora:  {this.props.indicator.inv_report[1].hora} <br />
                %Avance: {this.props.indicator.inv_report[1].avance + "%"} - %Auditoria: {this.props.indicator.inv_report[1].avance >= 50 && this.props.indicator.inv_report[1].auditoria < 15 ? <strong style={{ color: 'red' }}>{this.props.indicator.inv_report[1].auditoria + "%"}</strong> : this.props.indicator.inv_report[1].auditoria + "%"}  <br />
                Hora termino conteo estimada: {horaEstimada(this.props.indicator.inv_report[0].hora, this.props.indicator.inv_report[1].hora, this.props.indicator.inv_report[1].avance)} <br />
                {this.props.comentarioDashboard ? (this.props.indicator.inv_report[1].idUser ? "Reportado por: " + this.props.indicator.inv_report[1].idUser : "Usuario encargado de reportar no registrado") : null}
            </p> :
            ""
        let statusReporte3 = this.props.indicator.inv_report.length == 3 ?
            (this.props.indicator.indicator.id_file ?
                <p style={{ fontSize: '12px' }}>3. Finalizado. <br />
                    El proceso de inventario ha finalizado siendo las {this.props.indicator.inv_report[2].hora} hrs <br />
                    Tiempo de revision de {this.props.indicator.indicator.tiempo_conteo} <br />
                    Con una evaluacion total de {this.props.indicator.indicator.avg_scores} <br />
                    Con porcentaje de error de {this.props.indicator.indicator.sei_error}%, nivel de cumplimiento de {this.props.indicator.indicator.sei_standard}% <br />
                    Y las siguientes obeservaciones: {this.props.indicator.deterioro ? "Si se genera deterioro" : "No se genera deterioro"} <br />
                    {this.props.comentarioDashboard ? (this.props.indicator.inv_report[2].idUser ? "Reportado por: " + this.props.indicator.inv_report[2].idUser : "Usuario encargado de reportar no registrado") : null}
                </p> :
                "3. Finalizado.") :
            ""

        let spanReporte = <span className={style.tooltiptextReporte}>{this.props.indicator.client_name + " " + this.props.indicator.store_number + " " + this.props.indicator.store_commune + " / " + this.props.indicator.leader + " - " + this.props.indicator.horario} hrs.<br />
            Hora inicio: {this.props.indicator.inv_report.length > 0 ? this.props.indicator.inv_report[0].hora : "Aún no iniciado"}<br />
            {statusReporte1}
            {statusReporte2}
            {statusReporte3}
        </span>

        let tdIGHour = <td className={(this.props.permissions ? style.tooltip : '')}>{this.props.permissions ? (this.props.indicator.client_name == 'FCV' ?
            (this.props.indicator.indicator.ig_hours >= '09:15:00' ?
                <strong style={{ color: 'red' }}>{this.props.indicator.indicator.ig_hours}</strong> : this.props.indicator.indicator.ig_hours)
            : (this.props.indicator.client_name == 'MAI' ?
                (this.props.indicator.indicator.ig_hours >= '10:15:00' ?
                    <strong style={{ color: 'red' }}>{this.props.indicator.indicator.ig_hours}</strong> : this.props.indicator.indicator.ig_hours)
                : (this.props.indicator.indicator.ig_hours >= '10:00:00' ? <strong>{this.props.indicator.indicator.ig_hours}</strong> : this.props.indicator.indicator.ig_hours))) : this.props.indicator.indicator.ig_hours}
            {this.props.permissions && this.props.indicator.indicator.ig_hours ? <span className={style.tooltiptext}>
                <div>
                    {this.props.indicator.indicator.hora_inicio ? <p style={{ padding: '2px' }}>Hora Inicio Conteo: {this.props.indicator.indicator.hora_inicio}</p> : null}
                    {this.props.indicator.indicator.hora_fin_conteo ? <p style={{ padding: '2px' }}>Hora Fin Conteo: {this.props.indicator.indicator.hora_fin_conteo}</p> : null}
                    {this.props.indicator.indicator.fecha_grilla ? <p style={{ padding: '2px' }}>Hora Término Grilla: {this.props.indicator.indicator.fecha_grilla}</p> : null}
                    {this.props.indicator.indicator.hora_inicio_revision ? <p style={{ padding: '2px' }}>Hora Inicio Revisión: {this.props.indicator.indicator.hora_inicio_revision}</p> : null}
                    {this.props.indicator.indicator.hora_fin_revision ? <p style={{ padding: '2px' }}>Hora Fin Revisión: {this.props.indicator.indicator.hora_fin_revision}</p> : null}
                    {this.props.indicator.indicator.hora_subida_archivo ? <p style={{ padding: '2px' }}>Hora Fin Proceso: {this.props.indicator.indicator.hora_subida_archivo}</p> : null}
                </div>
            </span> : null}
        </td>

        let cantidadDotacion = Object.values(this.props.indicator.indicator).length > 0 ? this.props.indicator.indicator.tooltip_titulares.length : ''
        return <tr style={{ backgroundColor: styleTR }}>
            {this.props.perms.backups ? <td>
                <a className="btn btn-success btn-xs"
                    href={`/inventario/${this.props.indicator.inv}/backups`}>
                    <span className="glyphicon glyphicon-cloud"></span>
                </a>
            </td> : null}
            {this.props.reportar ?
                (this.props.indicator.inv_report == 0 ? (this.state.atrasado ? <td className={style.tooltip}>
                    <a className="btn btn-danger btn-xs"
                        href={`/api/reporte/inventarios/${this.props.indicator.inv}`}>
                        <span className="glyphicon glyphicon-comment"></span>
                        {spanReporte}
                    </a>
                </td> : (this.state.iniciado ? <td className={style.tooltip}>
                    <a className="btn btn-success btn-xs"
                        href={`/api/reporte/inventarios/${this.props.indicator.inv}`}>
                        <span className="glyphicon glyphicon-comment"></span>
                        {spanReporte}
                    </a>
                </td> : <td className={style.tooltip}>
                    <a className="btn btn-default btn-xs"
                        href={`/api/reporte/inventarios/${this.props.indicator.inv}`}>
                        <span className="glyphicon glyphicon-comment"></span>
                        {spanReporte}
                    </a>
                </td>)) :
                    (this.props.indicator.inv_report.length == 1 ? <td className={style.tooltip}>
                        <a className="btn btn-success btn-xs"
                            href={`/api/reporte/inventarios/${this.props.indicator.inv}`}>
                            <span className="glyphicon glyphicon-comment"></span>
                            {spanReporte}
                        </a>
                    </td> :
                        (this.props.indicator.inv_report.length == 2 ? <td className={style.tooltip}>
                            <a className="btn btn-warning btn-xs"
                                href={`/api/reporte/inventarios/${this.props.indicator.inv}`}>
                                <span className="glyphicon glyphicon-comment"></span>
                                {spanReporte}
                            </a>
                        </td> : <td className={style.tooltip}>
                            <a className="btn btn-primary btn-xs"
                                href={`/api/reporte/inventarios/${this.props.indicator.inv}`}>
                                <span className="glyphicon glyphicon-comment"></span>
                                {spanReporte}
                            </a>
                        </td>))) :
                (<td className={style.tooltip}>
                    <p>
                        {this.props.indicator.inv_report == 0 ? (this.state.atrasado ? <input className={style.radioButtonRojo} type="radio" defaultChecked /> : (this.state.iniciado ? <input className={style.radioButton1} type="radio" defaultChecked /> : <input className={style.radioButton0} type="radio" defaultChecked />)) :
                            (this.props.indicator.inv_report.length == 1 ? <input className={style.radioButton1} type="radio" defaultChecked /> :
                                (this.props.indicator.inv_report.length == 2 ? <input className={style.radioButton2} type="radio" defaultChecked /> :
                                    (<input className={style.radioButton3} type="radio" defaultChecked />)))}
                        {spanReporte}
                    </p>
                </td>)
            }
            {/* TOOLTIP DE AVANCE DE INVENTARIO */}
            {this.props.permissions ? (this.props.indicator.avance ? <td className={style.tooltipAvance}>
                <i className="glyphicon glyphicon-signal"
                    style={{
                        color: this.props.indicator.avance.online ? 'green' : 'red',
                        cursor: 'help',
                        fontSize: '16px',
                    }}
                ></i>
                <span className={style.tooltiptextAvance}
                    style={{
                        minWidth: '280px',
                        backgroundColor: '#1f1f1f',
                        color: '#fff',
                        padding: '5px 7px',
                        borderRadius: '8px',
                        fontSize: '10px',
                        lineHeight: '1.0',
                        boxShadow: '0 0 8px rgba(0,0,0,0.4)',
                        textAlign: 'left',
                    }}>
                    <div style={{ fontWeight: 'bold', fontSize: '13px', marginBottom: '6px' }}>
                        Avance de inventario
                    </div>
                    {/* Barra de progreso */}
                    <div style={{
                        width: '100%',
                        height: '4px',
                        backgroundColor: '#333',
                        borderRadius: '3px',
                        marginBottom: '5px',
                    }}>
                        <div style={{
                            width: `${this.props.indicator.avance.por_avance_unidades}%`,
                            height: '100%',
                            backgroundColor: '#00bcd4',
                            borderRadius: '3px',
                            transition: 'width 0.5s',
                        }}
                        ></div>
                    </div>
                    <div style={{ fontSize: '11px', marginBottom: '8px' }}>
                        <b>{parseFloat(this.props.indicator.avance.por_avance_unidades).toFixed(1)}%</b>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <b>Local</b>
                        <span>{this.props.indicator.avance.nombre_local}</span>
                    </div>
                    <div>
                        <b>Hora de inicio programada:</b> {this.props.indicator.avance.hora_inicio_programada}
                        <br />
                        <b>Hora de inicio real:</b>{' '}
                        <span style={{ fontWeight: 'bold' }}>{this.props.indicator.avance.hora_inicio_real}</span>
                        <br />
                        <b>Tiempo proceso:</b> {this.props.indicator.avance.tiempo_transcurrido_hora_capturando}
                        <br />
                        <b>Tiempo restante:</b> {this.props.indicator.avance.tiempo_faltante_hora_captura}
                        <br />
                        <b>Hora de término aprox:</b> {this.props.indicator.avance.fecha_estimada_cierre}
                        <br />
                        <b>Dotación total:</b> {this.props.indicator.avance.dotacion_diferencia}
                    </div>
                    <hr style={{ border: '0.5px solid #444', margin: '8px 0' }} />
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>Stock teórico</span>
                        <span>{parseInt(this.props.indicator.avance.cantidad_teorica).toLocaleString()} (100%)</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>Avance uni. contadas</span>
                        <span>
                            {parseInt(this.props.indicator.avance.cantidad_fisica).toLocaleString()} (
                            {parseFloat(this.props.indicator.avance.por_avance_unidades).toFixed(1)}%)
                        </span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>Avance sala</span>
                        <span>{parseFloat(this.props.indicator.avance.por_avance_sala).toFixed(1)}%</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>Avance bodega</span>
                        <span>{parseFloat(this.props.indicator.avance.por_avance_bodega).toFixed(1)}%</span>
                    </div>
                    <hr style={{ border: '0.5px solid #444', margin: '8px 0' }} />
                    <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Auditoría</div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>Hora de inicio</span>
                        <span>{this.props.indicator.avance.fecha_inicio_auditoria}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>Avance ítems</span>
                        <span>{parseFloat(this.props.indicator.avance.por_avance_auditoria).toFixed(1)}%</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>Error</span>
                        <span>{parseFloat(this.props.indicator.avance.por_nivel_error).toFixed(1)}%</span>
                    </div>
                    <hr style={{ border: '0.5px solid #444', margin: '8px 0' }} />
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span style={{ fontWeight: 'bold' }}>Líder SEI</span>
                        <span>{this.props.indicator.avance.nombre_lider}</span>
                    </div>
                </span>
            </td> : <td>
                <i className="glyphicon glyphicon-signal" style={{ color: 'gray' }}
                ></i>
            </td>) : null}
            {/* this.props.admin == true ? null : */<td>{this.props.indicator.client_name}</td>}
            <td className={style.PanelIndicators_tdStoreNumber}>{this.props.indicator.store_number}{this.props.permissions ? spanNomina : null}</td>
            <td className={style.PanelIndicators_tdStoreName} title={this.props.indicator.store_name} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100px' }}>{this.props.indicator.store_name}</td>
            <td className={style.PanelIndicators_tdSupervisorName} style={{ whiteSpace: 'nowrap' }}>{this.props.indicator.leader}</td>
            <td className={style.PanelIndicators_tdStoreNumber}>{cantidadDotacion}</td>
            <td className={style.PanelIndicators_tdRightTextTwo}>{this.props.indicator.indicator.units_counted}</td>
            {this.props.unDesviadas ? <td>{this.props.indicator.indicator.diff_counted_informed}</td> : null}
            {tdIGHour}
            {this.props.permissions ? tdNotaConteo : null}
            {this.props.permissions ? <td className={style.tooltip}>{this.props.indicator.indicator.nota_presentacion}{this.props.indicator.indicator.incumplimientos_sei && this.props.indicator.indicator.incumplimientos_sei.notaPresentacion && <span className={style.tooltiptext} style={{ width: '400px', whiteSpace: 'normal' }}><strong>Incumplimiento: </strong>{this.props.indicator.indicator.incumplimientos_sei.notaPresentacion.observacion ? this.props.indicator.indicator.incumplimientos_sei.notaPresentacion.observacion : 'Sin observaciones aún...'}</span>}</td> : null}
            {this.props.permissions ? <td className={style.tooltip}>{this.props.indicator.indicator.nota_supervisor}{this.props.indicator.indicator.incumplimientos_sei && this.props.indicator.indicator.incumplimientos_sei.notaSupervisor && <span className={style.tooltiptext} style={{ width: '400px', whiteSpace: 'normal' }}><strong>Incumplimiento: </strong>{this.props.indicator.indicator.incumplimientos_sei.notaSupervisor.observacion ? this.props.indicator.indicator.incumplimientos_sei.notaSupervisor.observacion : 'Sin observaciones aún...'}</span>}</td> : null}
            <td className={!this.props.permissions ? style.tooltip : ''}>{this.props.indicator.indicator.avg_scores}
                {!this.props.permissions ? <span className={style.tooltiptext}>
                    Nota Conteo: {this.props.indicator.indicator.nota_conteo} <br />
                    Nota Presentación: {this.props.indicator.indicator.nota_presentacion} <br />
                    Nota Supervisor: {this.props.indicator.indicator.nota_supervisor}
                </span> : null}
            </td>
            <td className={style.tooltip}>{this.props.permissions ?
                (this.props.indicator.indicator.sei_error ?
                    (parseFloat(this.props.indicator.indicator.sei_error).toFixed(1) >= 1 ?
                        <strong style={{ color: 'red' }}>
                            {parseFloat(this.props.indicator.indicator.sei_error).toFixed(1).concat('%')}
                        </strong> :
                        (parseFloat(this.props.indicator.indicator.sei_error).toFixed(1) < 1 ?
                            (this.props.indicator.indicator.error_operadores == true ?
                                <strong>
                                    {parseFloat(this.props.indicator.indicator.sei_error).toFixed(1).concat('%')}
                                </strong> :
                                parseFloat(this.props.indicator.indicator.sei_error).toFixed(1).concat('%')) :
                            parseFloat(this.props.indicator.indicator.sei_error).toFixed(1).concat('%'))) :
                    null) :
                (this.props.indicator.indicator.sei_error ?
                    parseFloat(this.props.indicator.indicator.sei_error).toFixed(1).concat('%') :
                    null)
            }
                {span}
            </td>
            {showModalBloqueo && (
                <ModalBloqueo
                    show={showModalBloqueo}
                    onClose={this.cerrarModalBloqueo}
                    idUsuario={selectedUserId}
                    clientName={selectedClient}
                    usuario={selectedUser}
                />
            )}
            <td className={this.props.permissions ? style.tooltip : ''}>{(this.props.indicator.indicator.sei_standard ?
                (parseFloat(this.props.indicator.indicator.sei_standard).toFixed(1) < 95 && this.props.permissions ?
                    <strong style={{ color: 'red' }}>
                        {parseFloat(this.props.indicator.indicator.sei_standard).toFixed(1).concat('%')}
                    </strong> :
                    parseFloat(this.props.indicator.indicator.sei_standard).toFixed(1).concat('%')) :
                null)}
                {this.props.permissions && Array.isArray(this.props.indicator.indicator.no_cumplidos) &&
                    this.props.indicator.indicator.no_cumplidos.length > 0 ? (
                    <span className={style.tooltiptext} style={{ width: '500px', whiteSpace: 'normal' }}>
                        <p><strong>Preguntas NO cumplidas</strong></p>
                        {(<ol style={{ margin: 0, paddingLeft: 18 }}>
                            {this.props.indicator.indicator.no_cumplidos.map((item, index) => {
                                const incumplimientos = this.props.indicator.indicator.incumplimientos_sei;
                                const estandares = incumplimientos && incumplimientos.estandarSei && incumplimientos.estandarSei.estandares_sei;
                                const comentario = estandares && estandares[index]
                                    ? `Observación pregunta: ${estandares[index].comentario}`
                                    : 'Sin observaciones aún...';
                                return (
                                    <li key={index}>
                                        {item}
                                        <p style={{ color: 'orange' }}>
                                            {comentario}
                                        </p>
                                    </li>
                                );
                            })}
                        </ol>
                        )}
                        <br />
                        {/* {this.props.indicator.indicator.incumplimientos_sei.estandarSei ? <p style={{ color: 'orange' }}><strong>Observación incumplimiento:</strong> {this.props.indicator.indicator.incumplimientos_sei.estandarSei.observacion ? this.props.indicator.indicator.incumplimientos_sei.estandarSei.observacion : 'Sin observaciones aún...'}</p> : null} */}
                    </span>
                ) : null}
            </td>
            {this.props.showOtherData ?
                tdVariance : null
            }
            {this.props.permissions || this.props.fcv ? tdTiempoConteo : tdFCVConteo}
            <td>{(this.props.indicator.indicator.ptt_rev_rate ?
                (parseFloat(this.props.indicator.indicator.ptt_rev_rate).toFixed(1) < 30 && (this.props.fcv || this.props.permissions) ?
                    <strong style={{ color: 'red' }}>
                        {parseFloat(this.props.indicator.indicator.ptt_rev_rate).toFixed(1).concat('%')}
                    </strong> :
                    (parseFloat(this.props.indicator.indicator.ptt_rev_rate).toFixed(1) <= 50 && (this.props.perms.permFSB) ?
                        <strong style={{ color: 'red' }}>
                            {parseFloat(this.props.indicator.indicator.ptt_rev_rate).toFixed(1).concat('%')}
                        </strong> :
                        this.props.indicator.indicator.ptt_rev_rate.concat('%'))) : this.props.indicator.indicator.ptt_rev_rate)}</td>
            <td>{this.props.indicator.indicator.items_rev_rate}
            </td>
            <td className={style.tooltip}>
                {(parseFloat(this.props.indicator.indicator.error_client).toFixed(1) > 1 ?
                    <strong style={{ color: 'red' }}>
                        {this.props.indicator.indicator.error_client}
                    </strong> :
                    this.props.indicator.indicator.error_client)}
                {this.props.permissions ? (this.props.indicator.indicator.error_client ? spanJL : null) : null}
            </td>
            <td>{this.props.indicator.indicator.client_standard}</td>
            <td className={style.PanelIndicators_tdRightTextTwo + ' ' + (this.props.permissions && this.props.indicator.indicator.resultado_final ? style.tooltipNeto : '')}>{this.props.indicator.indicator.difference_neto ? (this.props.indicator.indicator.difference_neto / 1000).toLocaleString("es-CL", { style: "decimal", minimumFractionDigits: 0, maximumFractionDigits: 0 }) : this.props.indicator.indicator.difference_neto}
                {this.props.permissions ? <span className={style.tooltiptextNeto}>{this.props.indicator.indicator.resultado_final}</span>  : null}
            </td>
            {this.props.permissions ?
                <td>
                    <a className="btn btn-primary btn-xs"
                        href={`/inventario/${this.props.indicator.inv}/archivo-final`} target={"_blank"}>
                        <span className="glyphicon glyphicon-list-alt"></span>
                    </a>
                </td> : null
            }
            <td className={style.tooltipInicio}>
                {this.props.indicator.indicator.id_file ?

                    (this.props.permissions ? <button className="btn btn-primary btn-xs"
                        //href={`/inventario/archivo-final/${this.props.indicator.indicator.id_file}/descargar-acta`}
                        onClick={() => this.props.openModalActa(this.props.indicator.inv)}>
                        <span className="glyphicon glyphicon-list">
                        </span>
                    </button> : <button className="btn btn-primary btn-xs"
                        //href={`/inventario/archivo-final/${this.props.indicator.indicator.id_file}/descargar-acta`}
                        onClick={() => this.props.openModalActaCliente(this.props.indicator.inv)}>
                        <span className="glyphicon glyphicon-file">
                        </span>
                    </button>)
                    :
                    <a className="btn btn-warning btn-xs">
                        <span className="glyphicon glyphicon-time"></span>
                    </a>
                }
            </td>
            <td>
                {this.props.indicator.indicator.id_file ?
                    <button className="btn btn-info btn-xs"
                        onClick={() => this.props.openModalChecklist(this.props.indicator.inv)}>
                        <span className="glyphicon glyphicon-list-alt"></span>
                    </button>
                    :
                    <a className="btn btn-warning btn-xs">
                        <span className="glyphicon glyphicon-time"></span>
                    </a>
                }
            </td>
            <td>
                {this.props.indicator.indicator.id_file ?
                    <button className="btn btn-info btn-xs"
                        onClick={() => this.props.openModalImagenes(this.props.indicator.inv)}>
                        <span className="glyphicon glyphicon-picture"></span>
                    </button>
                    :
                    <a className="btn btn-warning btn-xs">
                        <span className="glyphicon glyphicon-time"></span>
                    </a>
                }
            </td>
            <td>
                {this.props.indicator.indicator.id_file ?
                    <a className="btn btn-success btn-xs"
                        href={`/inventario/archivo-final/${this.props.indicator.indicator.id_file}/descargar`}>
                        <span className="glyphicon glyphicon-download"></span>
                    </a>
                    :
                    <a className="btn btn-warning btn-xs">
                        <span className="glyphicon glyphicon-time"></span>
                    </a>
                }
            </td>
            <td>{cargatxt === true && (this.props.indicator.client_name == "PUC" || this.props.indicator.client_name == "FSB") && this.props.indicator.fecha >= "2023-01-30" ? <ButtonArchivoPUC indicator={this.props.indicator} /> : ""} </td>
            <td>
                {this.props.perms.comentario_inv && <ComentarioIG idInventario={this.props.indicator.inv} />}
            </td>
        </tr>
    }
}


const miles = (number, mil = ".", decimal = ",") => {
    if (number == null) {
        return null;
    }
    var parts = number.toString().split(".");
    const numberPart = parts[0];
    const decimalPart = parts[1];
    const thousands = /\B(?=(\d{3})+(?!\d))/g;
    return numberPart.replace(thousands, mil) + (decimalPart ? decimal + decimalPart : "");
}
const aInt = (number) => {
    if (number == null) {
        return null;
    }
    var parts = number.toString().split(".");
    const numberPart = parts[0];
    const decimalPart = parts[1];
    return Number(numberPart.concat(decimalPart));
}

const horaEstimada = (horaInicio, horaAvance, avance) => {
    var partsIni = horaInicio.toString().split(":");
    var partsAva = horaAvance.toString().split(":");
    const horaPartIni = partsIni[0];
    const minutosPartIni = partsIni[1];
    const horaPartAva = partsAva[0];
    const minutosPartAva = partsAva[1];
    const numero1 = (Number(horaPartIni) * 60) + Number(minutosPartIni);
    const numero2 = (Number(horaPartAva) * 60) + Number(minutosPartAva);
    const minutos = numero2 < numero1 ? ((numero2 + 1440) - (numero1)) : ((numero2) - (numero1));
    //1440 son los minutos de 24 horas
    const diferencia = (((minutos * 100) / avance).toFixed() / 60)
    const test = diferencia.toString().split(".");
    const minutosEstimada = test[1] ? (diferencia > 0 ? ((Number(minutosPartIni)) + ((Number("0." + test[1]) * 60))).toFixed() : 60) : (diferencia > 0 ? ((Number(minutosPartIni)) + (0)).toFixed() : 60);
    const horaEstimada = (Number(horaPartIni) + Number(test[0]));
    const horaFinal = minutosEstimada >= 60 ?
        (horaEstimada + 1 >= 24 ? (((horaEstimada + 1) - 24) + ":" + (minutosEstimada - 60)) :
            (((horaEstimada + 1)) + ":" + (minutosEstimada - 60))) :
        (horaEstimada + 1 >= 24 ? (((horaEstimada + 1) - 24) + ":" + (minutosEstimada)) :
            (((horaEstimada + 1)) + ":" + (minutosEstimada)));
    const horaFix = horaFinal.toString().split(":");
    const hora = Number(horaFix[0]) + 1 < 10 ? "0" + (Number(horaFix[0]) + 1) : Number(horaFix[0]) + 1;
    const minuto = Number(horaFix[1]) < 10 ? "0" + (horaFix[1]) : (horaFix[1]);
    //return test;
    return hora + ":" + minuto;
}

/*const updateTime = (horaInicio, horaActual) => {

}*/



// WEBPACK FOOTER //
// ./frontEnd/home/components/managementIndicators/RowIndicators.jsx